import { debounce } from "@app/scripts/utils/debounce";
import { FacetAction } from "./facet-action";

class FacetPriceRange extends HTMLElement {
    private debounceWait: number;

    constructor() {
        super();
        this.debounceWait = 200;
        this.bindEvents();
    }

    bindEvents() {
        const inputElements = this.querySelectorAll("input");
        inputElements.forEach((input) => {
            input.addEventListener("keyup", debounce((event: Event) => {
                this.onInputChange(event);
            }, this.debounceWait))
        })

        const applyButton = this.querySelector(".collection__facet-price-action .apply");
        applyButton?.addEventListener("click", this.applyPriceFilter.bind(this));
    }

    onInputChange(event: Event) {
       
    }

    applyPriceFilter(event: Event) {
        const minInput = this.querySelector("input.min") as HTMLInputElement;
        const maxInput = this.querySelector("input.max") as HTMLInputElement;
        const defaultMaxprice = Number(maxInput.getAttribute("data-max"));

        const minPrice = minInput.value ? Number(minInput.value) : 0;
        const maxPrice = maxInput?.value ? Number(maxInput?.value) : defaultMaxprice;

        const url = this.generateURLHash(minPrice, maxPrice);
        const facetAction = new FacetAction();
        facetAction.updateURLHash(url);
        facetAction.fetchPageContent(url);
    }

    generateURLHash(minPrice: number, maxPrice: number) {
        // const value = this.getAttribute("value") as string;
        let url = new URL(window.location.href);
        let params = new URLSearchParams(url.search);

        params.set('filter.v.price.gte', minPrice.toString());
        params.set('filter.v.price.lte', maxPrice.toString());
        url.search = params.toString();
        return url.href;
    }
    
}

customElements.define("facet-price-range", FacetPriceRange);
